export enum NumberingFormatAutotext {
    Day,
    Month,
    Year,
    Number
}
